<script lang="ts">
  // Login mask shown before the app when there's no session.
  import { createEventDispatcher } from "svelte";
  import { login } from "./api";
  import { currentUser } from "./stores";

  const dispatch = createEventDispatcher<{ loggedin: void }>();

  let username = "";
  let password = "";
  let error = "";
  let busy = false;

  async function submit(): Promise<void> {
    if (busy) return;
    busy = true;
    error = "";
    try {
      const u = await login(username.trim(), password);
      currentUser.set(u);
      dispatch("loggedin");
    } catch (e) {
      error = String(e).replace(/^Error:\s*/, "");
    } finally {
      busy = false;
    }
  }
</script>

<div class="login-mask">
  <form class="login-card" on:submit|preventDefault={submit}>
    <h1>Karlsruhe Cameras</h1>
    <label>
      Username
      <input bind:value={username} autocomplete="username" autofocus />
    </label>
    <label>
      Password
      <input type="password" bind:value={password} autocomplete="current-password" />
    </label>
    {#if error}<div class="login-error">{error}</div>{/if}
    <button class="primary" type="submit" disabled={busy || !username || !password}>
      {busy ? "Signing in…" : "Log in"}
    </button>
  </form>
</div>
